import { UI, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { Box, FlatList } from 'native-base';
import React from 'react';

import { ContractedProductItem, ContractedProductItemLoading } from '../ContractedProductItem';

import { ContractedProductsTypes } from '.';

const MobileSeparator = () => (
  <Box width="full" height="1px" bgColor={Color['neutral.lightest']} my={Spacing['stack.xxxs']} />
);

export const ContractedProductsMobile: React.FC<ContractedProductsTypes.Props> = ({
  isLoading,
  products,
}) => {
  const renderProducts = () => {
    if (isLoading) {
      return (
        <FlatList
          data={Array.from({ length: 3 })}
          showsVerticalScrollIndicator={false}
          numColumns={1}
          ItemSeparatorComponent={MobileSeparator}
          keyExtractor={(_, index) => index.toString()}
          renderItem={() => <ContractedProductItemLoading />}
        />
      );
    }

    return (
      <FlatList
        data={products}
        showsVerticalScrollIndicator={false}
        numColumns={1}
        ItemSeparatorComponent={MobileSeparator}
        keyExtractor={(item) => item.productName}
        renderItem={({ item }) => (
          <ContractedProductItem
            key={item.productName}
            productName={item.productName}
            contracted={item.contracted}
          />
        )}
      />
    );
  };

  return (
    <UI.Shadow
      level={1}
      borderRadius={BoxBorder.heavy}
      my={Spacing['inset.sm']}
      paddingX={Spacing['inline.xxxs']}
      paddingY={Spacing['inline.xxs']}>
      <VStack space={Spacing['stack.xxs']}>
        <UI.Text fontWeight="bold" color="neutral.darkest">
          Produtos Contratados
        </UI.Text>
        {renderProducts()}
      </VStack>
    </UI.Shadow>
  );
};
